<template>
    <div>
        <v-list :class="[{'listSmall': $vuetify.breakpoint.smAndUp}, 'ml-3 mt-2']">
            <v-btn class="my-3" color="primary" block @click="editTeam(null)">
                Neue Mannschaft anlegen
            </v-btn>
            <v-list-item v-for="(team, i) in teamList" :key="i" class="pl-1 pr-0">
                <span class="text-truncate">
                    {{team.name}} - <span v-if="saison.lvId==='1'">{{team.lvId}} </span>{{team.vereinsNr}}
                </span>
                <v-spacer></v-spacer>
                <v-btn icon @click="editTeam(team)"><v-icon>mdi-pencil</v-icon></v-btn>
                <saison-teams-delete :item="team" :document="saison"></saison-teams-delete>
            </v-list-item>
            <p v-if="teamList.length > 0" class="text-right mr-3 mt-2 grey--text">Gesamt: {{teamList.length}}</p>
        </v-list>
        <saison-teams-edit v-if="$route.query.action==='editSaisonTeams'"
                           :current-data="selectedTeam" :saison="saison">
        </saison-teams-edit>
    </div>
</template>

<script>
    import SaisonTeamsEdit from "./saisonTeamsEdit";
    import SaisonTeamsDelete from "./saisonTeamsDelete";

    export default {
        components: {
            SaisonTeamsDelete,
            SaisonTeamsEdit},
        name: "saison-teams",
        props: ['saison'],
        computed: {
            teamList(){return this.saison ? this.saison.getSortedTeamList() : [];}
        },
        data: () => ({
            selectedTeam: null,
            deleteSnack: null,
        }),
        methods: {
            editTeam(team){
                this.selectedTeam = team;
                this.openSaisonTeanEdit();
            },
                openSaisonTeanEdit(){
                    let p = JSON.parse(JSON.stringify(this.$route.path));
                    let q = JSON.parse(JSON.stringify(this.$route.query));
                    q.action = 'editSaisonTeams';
                    this.$router.push({path: p, query: q});
                },
        },
    }
</script>

<style scoped>
    .listSmall{width: 400px}
</style>